import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react'
import Plane from '../AbroadTicketBlock/images/desktopPlane';
import { connect } from 'react-redux';
import images from './images/images'

function UpperBlock({ apps }) {

    const [popExtraCountries, setPopExtraCountries] = useState(false);
    const [renderIcons, setrenderIcons] = useState(false);

    const dummyCountryData = [{
        country: "אנגליה",
        dataUsage: "100MB ליום ב 33$",
        smsUsage: "90 אג' לדקה שיחה/סמס"
    }];

    function renderExtraCountries() {
        return dummyCountryData.map(function(item, i) {
            return <div key={i} className="pink-pop-extra-box">
                <div className="where-flight-to-header">{item.country}</div>
                <div className="where-flight-to-text">{item.dataUsage}{item.smsUsage}</div>
            </div>
        });
    }

    function renderPlusMinusSign() {
       return popExtraCountries ? "x" : "+";
    }

    function renderIconBar() {
        return apps.map(function(app, i) {
            return (
            <div className="icon-bar-container">
                <Image className="icon" key={i} src={app} alt="app-icon" />
            </div>)
        });
        // return (
        //     <div className="icon-bar-container">
        //         <img className="icon" src={images.faceBookIcon}></img>
        //         <img className="icon" src={images.twitterIcon}></img>
        //         <img className="icon" src={images.youTubeIcon}></img>
        //         <img className="icon" src={images.instaIcon}></img>
        //         <img className="icon" src={images.instaIcon}></img>
        //     </div>
        // )
    }

    function renderStep(type) {
        switch(type) {
            case 'SIMPLE_HEADER': 
            return (
                <>
                    <div className="white-top-pic">
                        <Plane />
                    </div>
                    <div className="white-top-header">חבילת גולשים ונופשים</div>
                    <div className="white-top-text-box">
                        <div className="white-text-row">
                            <div className="white-top-text"> מלא טקסט</div>
                        </div>
                    </div>
                </>
            )
            case 'SIMPLE_HEADER_WITH_SPLIT': 
            return (
                <>
                    <div className="white-top-pic">
                        <Plane />
                    </div>
                    <div className="white-top-header">חבילת גולשים ונופשים</div>
                    <div className="white-top-text-box">
                        <div className="white-text-row">
                            <div className="white-top-text"> מלא טקסט</div>
                            <div className="white-top-text">&nbsp;|&nbsp;</div>
                            <div className="white-bottom-text">מלא טקסט </div>
                        </div>
                    </div>
                </>
            )
            case 'SIMPLE_HEADER_WITH_SPLIT_EXTRA_HEADER':
                return (
                    <>
                        <div className="white-top-pic">
                            <Plane />
                        </div>
                        <div className="white-top-header">חבילת גולשים ונופשים</div>
                        <div className="white-top-text-box">
                            <div className="white-text-row">
                                <div className="white-top-text"> מלא טקסט</div>
                                <div className="white-top-text">&nbsp;|&nbsp;</div>
                                <div className="white-bottom-text">מלא טקסט </div>
                            </div>
                            <div className="white-bottom-text">טקסט אקסטרה</div>
                        </div>
                    </>
                )
            case 'HEADER_WITH_APPS':
                return (
                    <>
                        <div className="white-top-pic">
                            <Plane />
                        </div>
                        <div className="white-top-header">חבילת גולשים ונופשים</div>
                        <div className="white-top-text-box">
                            <div className="white-text-row">
                                <div className="white-top-text"> מלא טקסט</div>
                                <div className="white-top-text">&nbsp;|&nbsp;</div>
                                <div className="white-bottom-text">מלא טקסט </div>
                            </div>
                            {renderIconBar()}
                            <div className="white-bottom-text">טקסט אקסטרה</div>
                        </div>
                    </>
                )
            case 'HEADER_POP_COUNTRIES': 
                return (
                    <>
                        <div className="white-top-box-container">
                        <div className="white-top-pic">
                            <Plane />
                        </div>
                        <div className="white-top-header">חבילת גולשים ונופשים</div>
                            <div className="white-top-text-box">
                                <div className="white-top-text">מלא טקסט</div>
                                <div className="pink-pop-text" onClick={() => setPopExtraCountries(!popExtraCountries)}>לתעריף כל המדינות {renderPlusMinusSign()}
                                    {popExtraCountries && renderExtraCountries()}
                                </div>
                            </div>
                        </div>
                    </>
            )
            default:
                return null;
        }
    }

    return (
        <div className="white-top-box-container">
            {renderStep("HEADER_POP_COUNTRIES")}
        </div>
    )
}

const mapStateToProps = (state) => ({
    data: state.cellcomAbroad,
    apps: state.cellcomAbroad.supportedSocialMediaApplications
});
  
const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(UpperBlock);